<div
  class="analysis-document-row"
  [attr.data-cy]="'required-doc-' + requiredDocument.name"
  [attr.data-status]="requiredDocument.isRequired ? 'required' : 'optional'">
  <div class="analysis-document-row__info">
    <h3 class="analysis-document-row__title">{{ documentLabel }}</h3>

    <span class="analysis-document-row__badge" *ngIf="requiredDocument.isRequired">
      Obrigatório
    </span>

    <p class="analysis-document-row__summary">{{ summary }}</p>
  </div>

  <div class="analysis-document-row__documents">
    <p class="analysis-document-row__empty" *ngIf="documents.length === 0">
      {{ noDocumentSentLabel }}
    </p>

    <app-analysis-document-pill
      *ngFor="let document of documents"
      [document]="document"
      [showYear]="!!requiredDocument.hasAnnualData"
      [submissionTooltip]="tooltipFor(submissionTooltips, document)"
      [analysisTooltip]="tooltipFor(analysisTooltips, document)"
      [statusLabels]="statusLabels"
      (documentSelect)="documentSelected.emit(document)">
    </app-analysis-document-pill>
  </div>
</div>
